export function getLanguagePart(locale: string): string {
    const matches = locale.match(/^[^-]+/);
    if (matches === undefined || matches === null || matches.length === 0) return "en";
    return matches[0];
}

// Apparently, the USA is the only country that officially still uses Imperial measurements.  The other two are
// currently converting to Metric.
export function shouldUseImperialUnits(locale: string): boolean {
    return /^en-US/.test(locale);
}
